import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ViolationTicketListPage" */
	'pages/vehicle/ViolationTicket/ViolationTicketListPage'));

export default [{ component, exact: true, path: '/violation_tickets' }];